import Seo from "@/components/Seo";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Products } from "../components/Products";
import { PriceChart } from "../components/PriceChart";
import { Manifesto } from "../components/Manifesto";
import { FoundersPreview } from "../components/FoundersPreview";
import { ContactSection } from "../components/ContactSection";

export default function Home() {
  return (
    <>
      <Seo
        title="Omkaar Metals Ltd — Copper Ingots 10% Below LME, Coal & Aluminium from Zambia"
        siteName="Omkaar Metals Ltd"
        description="Zambian exporter of copper ingots at 10% below LME prices (min 100 MT, 30% advance), plus coal in stock and aluminium ingots. Shipping worldwide from Lusaka, Zambia."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Omkaar Metals Ltd",
          identifier: "120261053235",
          address: { "@type": "PostalAddress", addressLocality: "Lusaka", addressCountry: "ZM" },
        }}
      />
      <Hero />
      <Marquee />
      <Products />
      <PriceChart />
      <Manifesto />
      <FoundersPreview />
      <ContactSection />
    </>
  );
}
